import { signOut, type Me } from '../api/client';
import { Button } from '../components/ui';
import { Hero } from './Landing';

/** Signed in, in no workspace: nothing to show, and nothing is fetched. */
export function EmptyState({ me }: { me: Me }) {
  const who = me.user.name ?? me.user.email ?? me.user.identity;
  return (
    <Hero>
      <h1>No workspace yet</h1>
      <p>
        You are signed in as <strong>{who}</strong>
        {me.user.email && me.user.name ? ` (${me.user.email})` : ''}, but you are not a member of a workspace.
      </p>
      <p className="text-ink-muted">Ask a workspace owner to add your terica email. You will see their board at your next visit.</p>
      <p>
        <Button
          onClick={async () => {
            await signOut();
            window.location.assign('/');
          }}
        >
          Sign out
        </Button>
      </p>
    </Hero>
  );
}
